import PlatformService from "@/services/Platform";
import RootPathMiddleware from "./middleware/root-path";
import webRoutes from "./web";
import appRoutes from "./app";
import NotFoundComponent from "@/pages/Shared/NotFound/NotFound";

/**
 * Shared routes between app and web
 */
const sharedRoutes = [
  {
    path: "/",
    beforeEnter: RootPathMiddleware,
    meta: {
      requiresAuth: false
    }
  },

  {
    path: "/sign-in",
    name: "Sign In",
    component: () =>
      import(/* webpackChunkName: "sign-in" */ "@/pages/Shared/SignIn/SignIn"),
    meta: {
      requiresAuth: false,
      requiresGuest: true
    }
  },
  {
    path: "/sign-in/with-email",
    name: "Sign In With Email",
    component: () =>
      import(
        /* webpackChunkName: "sign-in" */ "@/pages/Shared/SignIn/SignInWithEmail"
      ),
    meta: {
      requiresAuth: false,
      requiresGuest: true
    }
  },
  {
    path: "/lab",
    name: "Lab",
    component: () => import(/* webpackChunkName: "lab" */ "@/pages/Shared/Lab")
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: () =>
      import(/* webpackChunkName: "sign-in" */ "@/pages/Shared/ForgotPassword"),
    meta: {
      requiresAuth: false,
      requiresGuest: true
    }
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () =>
      import(/* webpackChunkName: "sign-in" */ "@/pages/Shared/ResetPassword"),
    meta: {
      requiresAuth: false,
      requiresGuest: true
    }
  },
  {
    path: "/account-settings",
    name: "Account Settings",
    component: () => import("@/pages/Shared/AccountSettings")
  },

  {
    path: "/support",
    name: "Support and Contact",
    component: () =>
      import("@/pages/Shared/SupportAndContact/SupportAndContact"),
    meta: {
      requiresAuth: false
    }
  }
];

/**
 * Define routes collection for router
 */
let routes = [...sharedRoutes];
if (PlatformService.isMobile()) {
  routes = [...routes, ...appRoutes];
}
if (PlatformService.isWeb()) {
  routes = [...routes, ...webRoutes];
}

/**
 * Last route in the list should be fallback
 */
routes = [
  ...routes,
  {
    path: "*",
    name: "Not Found",
    component: NotFoundComponent,
    meta: {
      requiresAuth: false
    }
  }
];

export default routes;
